/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import links from '../../../../config/links';

class HowTheChartsWorkInfoPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuShowed: false,
            displayMenuBelowAnchor: true,
        };
        this.handleAnchorClick = this.handleAnchorClick.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchend', this.handleClickOutside, false);
    }

    handleAnchorClick(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        // width reduced for Iphone 5 and small resolution devices
        let width = 300;
        if (window.innerWidth > 500) {
            width = 400;
        }

        let showBelow = true;
        if (ev.nativeEvent.clientY > (2 * window.innerHeight / 3)) {
            showBelow = false;
        }
        this.setState({
            isMenuShowed: true,
            displayMenuBelowAnchor: showBelow,
            hoverWidth: `${width}px`,
        });
    }

    closePopUp() {
        this.setState({
            isMenuShowed: false,
        });
    }

    render() {
        const PopUp = () => {
            return (
                <div
                    className={`rating-pop-up`}
                >

                    <div className="gradient-bar" />
                    <div className="pop-up-content">
                        {this.props.statsState.type === 'singles' && (
                            <>
                                <h5 className={`text`}>Rating History</h5>
                                <p className="text">
                                    View your rating trend over the past {this.props.monthsCount} months based on your match results and opponent ratings.
                                </p>
                                <br />
                            </>
                        )}
                        {this.props.statsState.type === 'doubles' && (
                            <>
                                <h5 className="text">Doubles Performance</h5>
                                <p className="text">
                                    The Performance graph shows the player’s performance over the selected period of time.
                                    The horizontal line represents the player’s current rating and the colored dots represent their matches. Click <a href={links.doublesPerformanceMetrics} target="_blank">here</a> for more details.
                                </p>
                                <br />
                            </>
                        )}
                        <h5 className="text">Results Analysis</h5>
                        <p className="text">
                            Visualize the impact of match results on your current rating based on two of the key inputs for the algorithm: games won % and opponent ratings.
                            Note that this chart does not factor each match’s weight in the total rating calculation as per the <a href={links.algorithmUnderstandingLink} target="_blank">complete algorithm summary</a>.
                        </p>
                        <br />

                        <a
                            onClick={() => {
                                this.closePopUp();
                            }}
                            className={`btn btn-default btn-block text-uppercase`}
                        >
                            <span>{this.props.cancelText}</span>
                        </a>
                    </div>
                </div>
            );
        };

        return (
            <div className={`info-root ${this.props.rootClass ? this.props.rootClass : ''}`}>
                <span className={this.props.linkTextClassName ? this.props.linkTextClassName : ''} onClick={this.handleAnchorClick}>{this.props.linkText}</span>
                {this.state.isMenuShowed && (
                    <div className="action-click-disabler" />
                )}
                <div
                    className={`info-container ${this.state.displayMenuBelowAnchor ? 'below-anchor' : 'above-anchor'} ${this.props.menuClass ? this.props.menuClass : ''}`}
                    style={{
                        width: this.state.hoverWidth,
                    }}
                >
                    {this.state.isMenuShowed && (
                        <PopUp />
                    )}
                </div>
            </div>

        );
    }
}

export default HowTheChartsWorkInfoPopup;
